module.exports = __webpack_public_path__ + "img/contact_illustration.fa28f71.jpg";